import { CanActivateFn } from '@angular/router';

export const publicGuard: CanActivateFn = () => true;
